

<!-- 就餐记录 -->

<template>
  <div id="diningRecords">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
        <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#diningRecords {
  height: 100%;
}
</style>
